import axios from "@/utils/request";
// 通知公告 - 列表
export const noticeList=(data:any)=>{
    return axios({
        path:"/onlineMedical/medicalComp/system/myNotice",
        data
    })
}

// 通知公告 - 接受
export const readNotice = (data:any)=>{
    return axios({
        path:"/onlineMedical/medicalComp/system/readNotice",
        method:"POST",
        data
    })
}
